import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { RequireAuth } from "@/components/RequireAuth";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { Toaster } from "@/components/ui/sonner";
import { homeForRole, PLATFORM_ROLES, TENANT_ROLES, CUSTOMER_ROLES } from "@/lib/auth";

import LoginPage from "@/portals/LoginPage";
import { ForgotPasswordPage, ResetPasswordPage } from "@/portals/PasswordPages";
import { TermsPage, PrivacyPage, CancellationPolicyPage, RefundPolicyPage } from "@/portals/LegalPages";
import PlatformLayout from "@/portals/platform/PlatformLayout";
import TruckstopLayout from "@/portals/truckstop/TruckstopLayout";
import CustomerLayout from "@/portals/customer/CustomerLayout";

const RootRedirect = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={homeForRole(user.role)} replace />;
};

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" />
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
            <Route path="/legal/terms" element={<TermsPage />} />
            <Route path="/legal/privacy" element={<PrivacyPage />} />
            <Route path="/legal/cancellation" element={<CancellationPolicyPage />} />
            <Route path="/legal/refund" element={<RefundPolicyPage />} />
            <Route path="/platform/*" element={
              <RequireAuth roles={PLATFORM_ROLES}><PlatformLayout /></RequireAuth>
            } />
            <Route path="/app/*" element={
              <RequireAuth roles={TENANT_ROLES}><TruckstopLayout /></RequireAuth>
            } />
            <Route path="/portal/*" element={
              <RequireAuth roles={CUSTOMER_ROLES}><CustomerLayout /></RequireAuth>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
